import { PaymentRequestV2Dto } from '../paymentRequestV2.dto';
import { IsOptional, IsString } from 'class-validator';

export class AibPaymentRequestDto extends PaymentRequestV2Dto {
  @IsString()
  timezone: string; // Client timezone

  // local time for the above timezone (!!!DO NOT SEND UTC if timezone is not a UTC one)
  @IsString()
  txndatetime: string; // Transaction Time

  @IsString()
  @IsOptional()
  aibPaymentMethod?: string; // Transaction Time // 'V', 'M', ... 'applePay', 'googlePay'

  /**
   * If you plan to embed our hosted payment page inside an iFrame you must use this parameter, with the maximum length of 2048 characters,
   * to specify an URL of a page, where the hosted payment page will be embedded.
   * However, note that we do not recommend using the hosted payment forms inside an iFrame since some Internet browsers do not allow
   * cookies to be sent to the 3rd party hosts, moreover some features (e.g.: 3-D Secure authentications) and some Alternative Payment
   * methods that involve redirections to the 3rd party services (e.g.: iDEAL or PayPal) do not allow displaying their screens within an iFrame.
   */
  @IsString()
  @IsOptional()
  parentUri?: string; // use this to tell the AIB Hosted Payment Page (Connect) that it is hosted inside an iframe. Needs to be included in the data sent to the page and also contribute with its value to the extendedHash

}